<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: 'Logout',
            icon: 'ni ni-user-run text-primary',
            path: '/logout'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Switch',
            icon: 'ni ni-compass-04 text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Go to LinkedIn', path: '/mysynchronicity-linkedin' }"></sidebar-item>
        </sidebar-item>
<!--        <sidebar-item-->
<!--          :link="{-->
<!--            name: 'Dashboards',-->
<!--            icon: 'ni ni-chart-pie-35 text-primary',-->
<!--          }"-->
<!--        >-->
<!--          <sidebar-item-->
<!--            :link="{ name: 'Overview', path: '/mysynchronicity-instagram' }"></sidebar-item>-->
<!--        </sidebar-item>-->
        <!--PROFILE-->
<!--        <sidebar-item-->
<!--          :link="{-->
<!--            name: 'Profile',-->
<!--            icon: 'ni ni-circle-08 text-primary',-->
<!--            path: '/instagram/profile'-->
<!--          }"-->
<!--        >-->
<!--        </sidebar-item>-->
        <sidebar-item
          :link="{
            name: 'Instagram',
            icon: 'ni ni-planet text-primary',
            path: '/instagram'
          }"
        >
          <sidebar-item
            :link="{ name: 'Add new Instagram', path: '/instagram/add-new-instagram' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Set new configuration', path: '/instagram/set-user-configuration' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Existing configuration', path: '/instagram/get-user-configuration' }"></sidebar-item>

        </sidebar-item>


      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
    /* eslint-disable no-new */
    import PerfectScrollbar from 'perfect-scrollbar';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';

    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() => {
                initScrollbar(className);
            }, 100);
        }
    }

    import DashboardNavbar from './SampleNavbar.vue';
    import ContentFooter from './SampleFooter.vue';
    import DashboardContent from '../Argon/Layout/Content.vue';
    import {FadeTransition} from 'vue2-transitions';

    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            DashboardContent,
            FadeTransition,
        },
        methods: {
            initScrollbar() {
                let docClasses = document.body.classList;
                let isWindows = navigator.platform.startsWith('Win');
                if (isWindows) {
                    // if we are on windows OS we activate the perfectScrollbar function
                    initScrollbar('scrollbar-inner');

                    docClasses.add('perfect-scrollbar-on');
                } else {
                    docClasses.add('perfect-scrollbar-off');
                }
            }
        }
    };
</script>
